module.exports = __webpack_public_path__ + "img/icon-2.be04328c.svg";